module.exports = __webpack_public_path__ + "img/d258777.jpg";